import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const handleAxiosError = (error: any, action: string) => {
  if (axios.isAxiosError(error)) {
    if (error.code === "ECONNABORTED") {
      console.error(` ${action}: Hết thời gian chờ.`);
      alert(`${action} thất bại: Máy chủ không phản hồi sau thời gian quy định.`);
    } else if (!error.response) {
      console.error(` ${action}: Lỗi mạng hoặc không kết nối được đến server.`);
      alert(`${action} thất bại: Không thể kết nối đến máy chủ.`);
    } else {
      console.error(` ${action}: Server trả về lỗi`, error.response);
      alert(`${action} thất bại: ${error.response.status} - ${error.response.statusText}`);
    }
  } else {
    console.error(` ${action}: Lỗi không xác định`, error);
    alert(`${action} thất bại do lỗi không xác định.`);
  }
  throw error; // Bắn lại nếu phía gọi cần xử lý tiếp
};

const feedbackService = {
  insertFeedback: async (feedbackData: any) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/feedback/insert_feedback`,
        feedbackData,
        {
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          timeout: 10000,
        }
      );
      return response.data;
    } catch (error) {
      handleAxiosError(error, "Gửi feedback");
    }
  },

  get_file_feedback: async (feedbackData: any) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/feedback/get_file_feedback`,
        feedbackData,
        {
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          timeout: 10000,
        }
      );
      return response.data;
    } catch (error) {
      handleAxiosError(error, "Lấy ảnh feedback");
    }
  },

  get_feedback_type: async (feedbackData: any) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/feedback/get_feedback_type`,
        feedbackData,
        {
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          timeout: 10000,
        }
      );
      return response.data;
    } catch (error) {
      handleAxiosError(error, "Lấy loại phản hồi ");
    }
  },

  getFeedback: async (feedbackData: any) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/feedback/get_feedback`,
        feedbackData,
        {
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          timeout: 10000,
        }
      );
      return response.data;
    } catch (error) {
      handleAxiosError(error, "Lấy feedback");
    }
  },

  getAreaByCode: async (code: string) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/area/getareabycode`,
        { are_code: code },
        {
          headers: { "Content-Type": "application/json" },
          timeout: 10000,
        }
      );
      return response.data;
    } catch (error) {
      handleAxiosError(error, "Lấy dữ liệu khu vực");
    }
  },
};

export default feedbackService;
